/**
 * Page title decorator script class
 *
 * @package    Decorators
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default (id, values = {}) => (WrappedComponent) => {
    return class PageTitleDecorator extends PureComponent {
        /**
         * @type {Object}
         */
        static contextTypes = {
            intl: PropTypes.object.isRequired,
        };

        componentDidMount() {
            this.setTitle(id, values);
        }

        /**
         * Set page title
         *
         * @param {String} title
         * @param {Object} values
         * @param {Boolean} translate
         */
        setTitle = (title, values = {}, translate = true) => {
            document.title = translate ? this.formatTitle(`title.${title}`, values) : title;
        };

        /**
         * Format title using react-intl
         *
         * @param {String} id
         * @param {Object} values
         *
         * @return {String}
         */
        formatTitle = (id, values = {}) => {
            return this.context.intl.formatMessage({ id }, values);
        };

        render() {
            return (
                <WrappedComponent { ...this.props } setTitle={ this.setTitle }/>
            );
        }
    };
};



// WEBPACK FOOTER //
// ./src/decorators/pageTitleDecorator.jsx